export default {
  creatingPrize: false,

  publishingPrize: false,
  prizeWasPublished: null,
  isPublishPrizeModalOpen: false,
  prizePublishErrors: [],

  currentPrizeId: null,
  isRelatedPrize: false,

  sectionsActiveGroups: {
    global: []
  }
};



// WEBPACK FOOTER //
// ./public/pages/EditPrize/initialState.js